import { PngIcon } from 'ui-kit';

export const HeaderLogo = () => (
  <>
    <span className="contents light:hidden">
      <PngIcon name="logo" alt="ORSNN" />
    </span>
    <span className="hidden light:contents">
      <PngIcon name="logo-light" alt="ORSNN" />
    </span>
  </>
);
